import { render, staticRenderFns } from "./ReminderMailSettings.vue?vue&type=template&id=4b13c58c&scoped=true"
import script from "./ReminderMailSettings.vue?vue&type=script&lang=ts"
export * from "./ReminderMailSettings.vue?vue&type=script&lang=ts"
import style0 from "./ReminderMailSettings.vue?vue&type=style&index=0&id=4b13c58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13c58c",
  null
  
)

export default component.exports